<template>
  <div>
    <h6>{{ $t("physical-archive.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-datasource-physical-archive"
      organizationScopedState="datasourcePhysicalArchive"
      libraryScopedState="physicalArchive"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourcePhysicalArchive/isUpdating"];
    },
    //

    editedDatasource() {
      return this.$store.getters["datasourcePhysicalArchive/editedDatasource"];
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("datasourcePhysicalArchive/resetForm");
    },

    interceptForSetParent(payload) {
      payload.datasource = this.editedDatasource;
    },
  },
};
</script>
